document.addEventListener('DOMContentLoaded', () => {
    const $tabs = $('.tab-item');
    const $productTabs = $('.product-tabs');
    $tabs.click(function () {
      $tabs.removeClass('active');
      $(this).addClass('active');
      let goid = $(this).data('goid');
      if ($(this).data('goid') == '') {
        $('html,body').animate({ scrollTop: $(this).closest('.shopify-section').next().offset().top - 100 }, 300);
    } else {
        $('html,body').animate({ scrollTop: $(goid).offset().top - 100 }, 300);
    }
    });
    $(window).scroll(function () {
      const scrollTop = $(this).scrollTop();
      const tabsOffset = $productTabs.offset().top;
      if (scrollTop >= tabsOffset && scrollTop < tabsOffset + $productTabs.outerHeight()) {
        $tabs.removeClass('active'); 
        $tabs.first().addClass('active');
      }
  });

  });